import {Serialisable} from "../serialisable";
import {OfflineImportFileType} from "./enums/offline-import-file-type.enum";

export class DashboardOfflineImportFileDto extends Serialisable {
    configId: number;
    branchId: number;
    offlineImportFileType: OfflineImportFileType;
    sqliteCreatedDateTimeUtc: number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/dashboard-offline-import-file.dto.ts